/**
 * 2D point coordinates.
 */
export interface Point {
  x: number;
  y: number;
}

/**
 * Camera state for viewport transformations.
 */
export interface Camera {
  position: Point;
  scale: number;
}

/**
 * Converts world coordinates to screen coordinates.
 * 
 * Args:
 *     pt: Point in world coordinates
 *     cam: Camera state
 * 
 * Returns:
 *     Point in screen coordinates
 */
export function worldToScreen(pt: Point, cam: Camera): Point {
  return {
    x: pt.x * cam.scale + cam.position.x,
    y: pt.y * cam.scale + cam.position.y,
  };
}

/**
 * Converts screen coordinates to world coordinates.
 * 
 * Args:
 *     pt: Point in screen coordinates
 *     cam: Camera state
 * 
 * Returns:
 *     Point in world coordinates
 */
export function screenToWorld(pt: Point, cam: Camera): Point {
  return {
    x: (pt.x - cam.position.x) / cam.scale,
    y: (pt.y - cam.position.y) / cam.scale,
  };
}